import { rule } from '../../domain/badge-composition-rule.js';
import { i18n } from '../../domain/i18n.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const d2cRules = composition => {
  const {isD2c, sandboxEnvironment, variantIs, check} = composition.checkers;

  return [
    rule('d2c')
      .when(isD2c)
      .set(() => ({
        parts: {
          aubySeal: {
            imageSrc: 'authorized-by-badge_d2c.svg',
          },
          contents: {
            texts: {
              originalityConfirmedTitle: i18n.contents.texts.originalityConfirmedTitle_d2c,
              originalityConfirmedText: i18n.contents.texts.originalityConfirmedText_d2c,
              authRetailerTitle: i18n.contents.texts.authRetailerTitle_d2c,
              authRetailerText: i18n.contents.texts.authRetailerText_d2c
            }
          },
        }
      })),
    rule('d2c/sandbox')
      .when(isD2c.and(sandboxEnvironment))
      .set(() => ({
        parts: {
          aubySeal: {
            imageSrc: 'authorized-by-badge_d2c_demo.svg',
          }
        }
      })),
    rule('d2c/no-tuv')
      .when(isD2c)
      .when(check(() => !composition.input.company.tuvApprovalDate))
      .set(() => ({
        parts: {
          contents: {
            texts: {
              shopCheckTitle: i18n.contents.texts.shopCheckTitle_noTuv_d2c,
              shopCheckText: i18n.contents.texts.shopCheckText_noTuv_d2c
            }
          },
        }
      })),
    rule('d2c/tuv')
      .when(isD2c)
      .when(check(() => composition.input.company.tuvApprovalDate))
      .set(() => ({
        parts: {
          contents: {
            texts: {
              shopCheckTitle: i18n.contents.texts.shopCheckTitle_d2c,
              shopCheckText: i18n.contents.texts.shopCheckText_d2c
            }
          },
        }
      })),
    rule('d2c/hide/header&footer')
      .when(isD2c)
      .when(variantIs('footer').or(variantIs('header')))
      .set(() => ({
        container: {
          show: false
        },
      })),
  ];
};
